import React, { FunctionComponent } from 'react'
import { majorScale, Heading, TextInputField } from 'evergreen-ui'
import MaskedInput from 'react-text-mask'
import DialogLayout from '../DialogLayout'

// When we support phone numbers outside of the US and Canada, this will need to be updated.
const maskValue = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

interface EnableSmsStepProps {
  onClickBack: () => void
  onClickNext: () => void
  onMobileNumberInputChange: (number: string) => void
  mobileNumber: string
}

const EnableSmsStep: FunctionComponent<EnableSmsStepProps> = ({
  onClickBack,
  onClickNext,
  onMobileNumberInputChange,
  mobileNumber
}) => (
  <DialogLayout
    onBackClick={onClickBack}
    onConfirmClick={onClickNext}
    confirmLabel="Next"
    confirmDisabled={mobileNumber.length !== 10}
  >
    <Heading size={600} marginBottom={majorScale(3)} textAlign="center">
      Provide a phone number
    </Heading>

    <MaskedInput
      mask={maskValue}
      onChange={e => onMobileNumberInputChange(e.target.value)}
      render={(ref, props) => (
        <TextInputField
          className="fullstory-exclude"
          innerRef={ref}
          {...props}
          type="tel"
          required
          autoComplete="tel-national"
          autoFocus
          placeholder="(123) 456-7890"
          label="Mobile phone number"
          description="Segment will send a security code to this mobile phone number whenever you log into the Segment website."
          hint="We currently only support numbers from the United States and Canada."
          marginBottom="0"
        />
      )}
    />
  </DialogLayout>
)

export default EnableSmsStep
